var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgB = function SvgB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h58v32H0zm58 0 18 15.5L58 32V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.208 15.304c1.242-.63 1.728-1.692 1.728-2.826 0-1.962-1.458-3.258-3.906-3.258h-4.482V22h5.13c2.466 0 3.942-1.476 3.942-3.546 0-1.656-.972-2.808-2.412-3.15Zm-4.23-4.068h1.71c1.224 0 1.944.63 1.944 1.674 0 .954-.648 1.728-1.836 1.728h-1.818v-3.402Zm2.25 8.766h-2.25v-3.456h2.358c1.134 0 1.836.612 1.836 1.674 0 1.098-.738 1.782-1.944 1.782Z",
    fill: "#fff"
  })));
};
export default SvgB;